module.exports = __webpack_public_path__ + "img/1490396086.eb4d01cd.jpg";